import { UserFavoriteUnit } from '@Models';
import {
  buildUserFavoriteUnitsState,
  UserFavoriteUnitsState,
} from '@Stores/index';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: UserFavoriteUnitsState = buildUserFavoriteUnitsState({
  entity: [],
}) satisfies UserFavoriteUnitsState as UserFavoriteUnitsState;

const userFavoriteUnitsSlice = createSlice({
  name: 'UserFavoriteUnits',
  initialState,
  reducers: {
    setError(state: UserFavoriteUnitsState, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
      state.hasError = true;
    },
    setLoading(state: UserFavoriteUnitsState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setUserFavoriteUnits(
      state: UserFavoriteUnitsState,
      action: PayloadAction<UserFavoriteUnit[]>,
    ) {
      state.entity = action.payload;
      state.isLoading = false;
      state.hasError = false;
      state.errorMessage = null;
    },
    addUserFavoriteUnit(
      state: UserFavoriteUnitsState,
      action: PayloadAction<UserFavoriteUnit>,
    ) {
      state.entity = [...state.entity!, action.payload];
    },
    removeUserFavoriteUnit(
      state: UserFavoriteUnitsState,
      action: PayloadAction<string>,
    ) {
      state.entity = state.entity!.filter((unit) => unit.id !== action.payload);
    },
  },
});

export default userFavoriteUnitsSlice;
